import { BiLogoGithub } from 'react-icons/bi'

import Logo from '../assets/logo.webp'

export default function Header() {
  const socials = [
    {
        icon: <BiLogoGithub />,
        location: 'https://github.com/PancakeTaste'
    }
  ]

  return (
    <div className='bg-primary'>
        <div className="container">
            <div className="py-8">
                <div className="flex items-center justify-between">
                    <img src={Logo} alt="Pancake logo" className='max-w-[125px]' />

                    <ul className='flex items-center space-x-3'>
                        {socials.map((item, idx) => (
                        <li key={idx}>
                            <a href={item.location} className='text-4xl text-bg' target='_blank' rel='noreferrer'>
                                {item.icon}
                            </a>
                        </li>
                        ))}
                    </ul>
                </div>
            </div>

            <hr />

            <h1 className='py-16 text-center text-5xl text-bg font-black'>Portfolio</h1>
        </div>
    </div>
  )
}
